import React, {useEffect, useState} from 'react';
import './Vault.scss';
import Paper from "@material-ui/core/Paper";
import * as _ from "lodash";
import {updateVaultDetails} from "../../utils/helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip";
import Divider from "@material-ui/core/Divider";
import routes from "../../utils/api-client";
import * as moment from "moment";
import {useAuth0} from "../../utils/providers/Auth0Provider";
import {Helmet} from 'react-helmet';
import {compose} from "redux";
import {connect} from "react-redux";
import {openConfirmationModal, toggleLoading} from "../../redux/reducers/utils";
import VaultDetails from "./VaultDetails";
import VaultStatus from "./VaultStatus";
import iziToast from "izitoast";
import AccessRequestModal from "./modals/AccessRequestModal";
import VaultActivity from "./VaultActivity";
import {finalize} from "rxjs/operators";
import {ADVISOR, OWNER, USER_ICON_MAPPING} from "../../config/constants";


function Vault(props) {

  const { loading } = useAuth0();
  let [vault, setVault] = useState();
  let [openAccessRequestModal, setOpenAccessRequestModal] = useState(false);

  const performVaultAction = (actionType, data={}) => {
    window.scrollTo(0, 0);
    const accessCode = _.get(props, 'accessRequestCode', null);
    let request$, successMessage;
    switch(actionType){
      case 'GET_VAULT_DETAILS':
        request$ =  accessCode ?
          routes.getVaultAccessRequest(props.vaultId, accessCode) :
          request$ = routes.getVault(props.vaultId);
        break;
      case 'APPROVE_VAULT_ACCESS_REQUEST':
        request$ =  accessCode ?
                      routes.approveVaultAccessRequestNoAuth(vault.id, accessCode) :
                      request$ = routes.approveVaultAccessRequestAuth(vault.id);
        successMessage = 'You have approved this request to access the vault.';
        break;
      case 'REJECT_VAULT_ACCESS_REQUEST':
        request$ = accessCode ?
                    routes.rejectVaultAccessRequestNoAuth(vault.id, accessCode) :
                    request$ = routes.rejectVaultAccessRequestAuth(vault.id);
        successMessage = 'You have rejected this request to access the vault.';
        break;
      case 'CANCEL_VAULT_ACCESS_REQUEST':
        request$ = routes.cancelAccessRequest(vault.id);
        successMessage = 'Successfully cancelled your request for access. The Vault Owner and Guardians have been notified.';
        break;
      case 'LOCK_VAULT':
        request$ = routes.lockVault(vault.id);
        successMessage = 'Successfully locked your vault.';
        break;
      case 'TOGGLE_VAULT_ARCHIVED':
        request$ = routes.toggleVaultArchived(vault.id);
        successMessage = `Successfully ${vault.status === 'ARCHIVED' ? 'un-archived' : 'archived'} your vault.`;
        break;
      case 'CREATE_ACCESS_REQUEST':
        request$ = routes.createAccessRequest(vault.id, data);
        successMessage = 'The Vault Owner and Guardians have been notified of your request.';
    }

    props.toggleLoading(true);
    request$.pipe(
      finalize(() => props.toggleLoading(false))
    )
      .subscribe((response) => {
        if (response.status === 400) {
          iziToast.error({
            position: "topCenter",
            'title': 'Error',
            'message': 'This action can not be performed. Your information on the Vault was outdated and has been refreshed.'
          });

          performVaultAction("GET_VAULT_DETAILS");

        } else if (response.status === 200) {
          if (successMessage) {
            iziToast.success({
              position: "topCenter",
              'title': 'Success',
              'message': successMessage
            });
          }
          setVault(updateVaultDetails(response.data));
        }
      });
  }



  useEffect(() => {
    // load vault details
    if (!loading) {
      performVaultAction('GET_VAULT_DETAILS');
    }
  }, [loading]);


  return (
    !!vault &&
    <div className="vault">
      <Helmet>
        <title>Fidelius Vaults: {vault.vault_name}</title>
      </Helmet>
      <div className="relative vault-content-outer-container">
        <p className="text-white bottom-spacer-small faded">Welcome to Vault:</p>
        <p className="text-white vault-name-text text-3xl md:text-5xl">{ vault.vault_name }</p>
        <div className="vault-name-divider bottom-spacer mt-3"/>
        <div className="flex items-center mb-3  ">
          <FontAwesomeIcon icon={USER_ICON_MAPPING[vault.role]} className="text-primary mr-2 text-lg md:text-xl"/>
          <p className="text-lg md:text-xl font-bold text-white">You're {_.includes([OWNER, ADVISOR], vault.role) ? 'the' : 'a'} <span className="text-primary">{vault.role}</span> of this vault.</p>
        </div>
        <div className="md:absolute vault-details-outer-container text-white mb-4 md:mb-0 text-sm md:text-base">
          <div className="flex items-center">
            <div className="font-bold vault-detail-title">Owner:</div>
            <div className="flex items-center">
              <p>{vault.owner_name}</p>
              <Tooltip enterTouchDelay={50} title={`Click to send an email to ${vault.owner_name}`}>
                <a onClick={() => window.location = `mailto:${vault.owner_email}?Subject=Vault '${vault.vault_name}' Question`}>
                  <FontAwesomeIcon icon="envelope" className="text-primary ml-2 cursor-pointer"/>
                </a>
              </Tooltip>

            </div>
          </div>
          <div className="md:mb-2 flex items-center">
            <div className="font-bold vault-detail-title">Purpose:</div>
            { vault.purposeDisplay }
          </div>
          <div className="flex items-center">
            <div className="font-bold vault-detail-title">Created:</div>
            { moment(vault.created).format('LLL') }
          </div>
          <div className="flex items-center">
            <div className="font-bold vault-detail-title">Updated:</div>
            { moment(vault.updated).format('LLL') }
          </div>
        </div>
        {
          vault.description &&
            <Tooltip title={vault.description} enterTouchDelay={50}>
              <p className="text-white hover:text-opacity-100 cursor-pointer text-opacity-50 text-sm md:text-base vault-description-text">{ vault.description }</p>
            </Tooltip>
        }

        <Paper className="mt-12">
          <p className="text-xl text-grey">Vault Status</p>
          <div className="mb-8 mt-5 sm:mt-0">
            <VaultStatus vault={vault}
                         performVaultAction={performVaultAction}
                         openAccessRequestModal={() => setOpenAccessRequestModal(true)}/>

          </div>
          <Divider/>
          <p className="text-xl text-grey mb-8 mt-3">Vault Details</p>
          <VaultDetails vault={vault}/>

          <Divider className="top-spacer-very-large bottom-spacer"/>
          <p className="text-xl text-grey bottom-spacer-large">Event Log</p>
          <VaultActivity vault={vault}/>
        </Paper>
      </div>

      {/*MODALS*/}
      <AccessRequestModal open={openAccessRequestModal}
                          vault={vault}
                          setVault={setVault}
                          performVaultAction={performVaultAction}
                          toggleModal={() => {setOpenAccessRequestModal(false)}}/>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading, openConfirmationModal }
  )
)(Vault);

